import React from 'react';

class ScrollForElement {
  constructor(elementClass) {
    this.elementClass = elementClass;
    this.classScroll = 'js-element-scroll';

    this.scrollElement = document.querySelector(`.${elementClass}`);
    this.adaptive = window.innerWidth <= 1024;
    this.body = document.body;
    this.header = document.querySelector(`.${elementClass}`);
  }

  init() {
    window.addEventListener('resize', () => {
      this.handleScroll();
    });
    document.addEventListener('scroll', () => {
      this.handleScroll();
    });
  }
  handleScroll() {
    if (window.innerWidth <= 768) {
      this.headerScrollHandler();
    } else {
      this.deleteScrollParams();
    }
  }
  headerScrollHandler() {
    const scrollBodyElement = this.scrollElement && this.scrollElement.querySelector(`.${this.elementClass}-wrapper`);

    const classScroll = this.classScroll;
    const previousElementPosition = this.getPreviousPosition();
    const previousElementHeight = this.scrollElement ? this.scrollElement?.previousElementSibling?.offsetHeight + 32 : 0;
    const topPositionScrollElement = previousElementPosition + previousElementHeight - 66;
    const elementMinHeight = scrollBodyElement ? scrollBodyElement.offsetHeight : 56;

    const checkIsActive = () => this.scrollElement && this.scrollElement.classList.contains(classScroll);
    const addedClass = () => this.scrollElement && this.scrollElement.classList.add(classScroll);
    const removeClass = () => this.scrollElement && this.scrollElement.classList.remove(classScroll);
    const checkIsTopPosition = () => window.pageYOffset >= topPositionScrollElement;

    if (checkIsTopPosition()) {
      if (this.scrollElement) this.scrollElement.style.minHeight = `${elementMinHeight}px`;
      !checkIsActive() && addedClass();
    } else {
      checkIsActive() && removeClass();
      if (this.scrollElement) this.scrollElement.style.minHeight = null;
    }
  }

  deleteScrollParams() {
    const classScroll = this.classScroll;
    if (!this.scrollElement) return;
    this.scrollElement.classList.remove(classScroll);
    this.scrollElement.style.minHeight = null;
  }
  getPreviousPosition() {
    if (!this.scrollElement) return 0;

    return this.scrollElement?.previousElementSibling?.offsetTop || this.scrollElement?.parentElement?.offsetTop;
  }
}

const scrollForElement = new ScrollForElement('booking-widget');
scrollForElement.init();
